import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { Typography } from '@mui/material';
import Loading from '../Loading';
import Box from '@mui/material/Box';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export function PdfViewer({ url, pageNumber, onDocumentLoadSuccess }) {
  const [error, setError] = useState(false);

  const handleOnLoadError = (e) => {
    console.log('Error loading pdf', e);
    setError(true);
  };

  if (error) {
    return <Typography>Erreur de chargement du pdf</Typography>;
  }

  const width = document.getElementById('pdfViewer')?.offsetWidth;

  return (
    <Box id="pdfViewer" sx={{ width: '100%', height: '100%' }}>
      <Document
        file={url}
        loading={<Loading />}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={handleOnLoadError}
      >
        <Page
          pageNumber={pageNumber}
          width={width}
          renderTextLayer={false}
          renderAnnotationLayer={false}
        />
      </Document>
    </Box>
  );
}
